import React from 'react';

interface Props {
    onSubscribe: () => void;
};

const Footer = (props: Props) => {
    const { onSubscribe } = props;

    return (
	<div className="footer">
	    <div className="links">
		<span onClick={onSubscribe}>Subscribe</span>
		<a target="_blank" href="https://anytype.io/faq">FAQ</a>
		<a target="_blank" href="https://community.anytype.io/">Forum</a>
		<a target="_blank" href="https://blog.anytype.io/">Blog</a>
		<a target="_blank" href="https://doc.anytype.io/anytype-docs/">Docs</a>
		<a target="_blank" href="https://t.me/anytype"><div className="icon telegram" /></a>
		<a target="_blank" href="https://github.com/anyproto"><div className="icon github" /></a>
		<a target="_blank" href="https://x.com/AnytypeLabs"><div className="icon twitter" /></a>
	    </div>

	    <div className="bottom">
		<div className="side left">
		    Made by Any — a Swiss association
		    <div className="icon swiss" />
		</div>

		<div className="side right">
		    <a target="_blank" href="https://anytype.io/website_privacy">Privacy Policy</a>
		    <a target="_blank" href="https://anytype.io/terms_of_use">Terms and conditions</a>
		</div>
	    </div>
	</div>
    );
};

export default Footer;